/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTransactionMetricsStatus200,
  GetTransactionMetricsStatus500,
} from '../types/GetTransactionMetrics'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTransactionMetrics } from '../clients/getTransactionMetrics'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTransactionMetricsQueryKey = () => [{ url: '/v1/transactions/metrics' }] as const

type GetTransactionMetricsQueryKey = ReturnType<typeof getTransactionMetricsQueryKey>

export function getTransactionMetricsQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTransactionMetricsQueryKey()
  return queryOptions<
    GetTransactionMetricsStatus200,
    ResponseErrorConfig<GetTransactionMetricsStatus500>,
    GetTransactionMetricsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTransactionMetrics({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Excludes MIGRATION transactions. Served from an in-process cache refreshed every DORA_TRANSACTION_METRICS_REFRESH_INTERVAL (default 10s), so values may lag by up to one interval.
 * @summary Get total transaction counts and the count from the last 24 hours
 * {@link /v1/transactions/metrics}
 */
export function useGetTransactionMetrics<
  TData = GetTransactionMetricsStatus200,
  TQueryData = GetTransactionMetricsStatus200,
  TQueryKey extends QueryKey = GetTransactionMetricsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTransactionMetricsStatus200,
        ResponseErrorConfig<GetTransactionMetricsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getTransactionMetricsQueryKey()

  const queryResult = useQuery(
    {
      ...getTransactionMetricsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetTransactionMetricsStatus500>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
